import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import { appendAuthParams } from "Common/TokenAuth/Utils";

export const selectRenewalSuite = ({ planSuiteID }) => {
  const companyIDToken = companyToken();
  const data = {
    ...(companyIDToken ? { company_id_token: companyIDToken } : {}),
    ...(planSuiteID ? { plan_suite_id: planSuiteID } : {}),
  };
  return fetchWithCSRFToken(appendAuthParams(`/employer-renewal/select-renewal-suite`), {
    method: "POST",
    body: JSON.stringify(data),
  });
};
